var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "height": "auto",
      "width": "60%",
      "scrollable": true,
      "name": "action-contravention",
      "classes": "modal_default",
      "clickToClose": true
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h3')]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._l((_vm.limitContravention), function(limitContraventionPerType, key) {
    return [(limitContraventionPerType.type === 'frequency') ? _vm._l((limitContraventionPerType.actions), function(lcpAction) {
      return _c('tr', [_c('td', [_vm._v("\n                                " + _vm._s(limitContraventionPerType.comment) + "\n                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                                " + _vm._s(lcpAction.visit_date) + "\n                            ")]), _vm._v(" "), _c('td', [(lcpAction.visit_id == _vm.$route.params.visitid) ? [_vm._v("\n                                    tato návštěva\n                                ")] : [_c('router-link', {
        attrs: {
          "to": {
            name: 'VisitDiagnosis',
            params: {
              clientid: _vm.$route.params.clientid,
              visitid: lcpAction.visit_id
            }
          },
          "target": "_blank"
        }
      }, [_vm._v("\n                                        zobrazit návštěvu "), _c('i', {
        staticClass: "fa fa-external-link",
        attrs: {
          "aria-hidden": "true"
        }
      })])]], 2)])
    }) : (limitContraventionPerType.type === 'non_contracted') ? [_c('tr', [_c('td', [_vm._v("\n                                " + _vm._s(limitContraventionPerType.comment) + "\n                            ")])])] : _vm._e()]
  })], 2)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-395423f4","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Visit/modals/ActionContravention.vue
// module id = 527
// module chunks = 0